export const USER_FORM_KEY = 'USER_FORM';
export const DEVICE_FORM_KEY = 'DEVICE_FORM';
export const DEVICE_NAME_FORM_KEY = 'DEVICE_NAME_FORM';
export const CUSTOMER_FORM_KEY = 'CUSTOMER_FORM';
export const LOGIN_FORM_KEY = 'LOGIN_FORM';
export const FORGOT_PASSWORD_FORM_KEY = 'FORGOT_PASSWORD_FORM';
export const CHANGE_PASSWORD_FORM_KEY = 'CHANGE_PASSWORD_FORM';
export const LOCATIONS_FORM_KEY = 'LOCATIONS_FORM';
export const UPDATE_LOCATION_FORM_KEY = 'UPDATE_LOCATION_FORM';
export const SITE_FORM_KEY = 'SITE_FORM';
export const EXPORT_ALL_LOGS_FORM_KEY = 'XPORT_ALL_LOGS_FORM';
